// src/App.jsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import ZionWifiBank from './pages/ZionWifiBank';
import TransactionStatus from './pages/TransactionStatus';
import UssdHome from './pages/UssdHome';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import UserManagement from './pages/UserManagement';
import PrivateRoute from './components/PrivateRoute';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <Routes>

        {/* Public Pages */}
        <Route path="/" element={<UssdHome />} />
        <Route path="/migration" element={<UssdHome migrationOnly />} />
        <Route path="/check-ticket" element={<TransactionStatus />} />
        <Route path="/packages" element={<ZionWifiBank />} />
        <Route path="/users" element={<UserManagement />} />

        {/* Admin Auth */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Protected Admin Routes */}
        <Route
          path="/admin/dashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/users"
          element={
            <PrivateRoute>
              <UserManagement />
            </PrivateRoute>
          }
        />

        {/* Catch-all 404 - MUST STAY LAST */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </Router>
  );
}

export default App;
